import { useMutation, useQueryClient } from '@tanstack/react-query';
import { createRegion } from 'API/Region/createRegion';

const useCreateRegion = (onSuccess, onError) => {
    const queryClient = useQueryClient();

    const create = async (regionData) => {
        const response = await createRegion(regionData);
        return response.data;
    };

    return useMutation({
        mutationFn: create,
        onSuccess: (data) => {
            queryClient.invalidateQueries({ queryKey: ['Regions'] });
            if (onSuccess) {
                onSuccess(data);
            }
        },
        onError: (error) => {
            if (onError) {
                onError(error);
            }
        },
    });
};

export default useCreateRegion;
